module.exports = __webpack_public_path__ + "img/makeshift-metal.8011ab58.jpg";